import { UFOExperience } from '@atlassian/ufo-experimental/experience';
import {
	ExperienceTypes,
	ExperiencePerformanceTypes,
} from '@atlassian/ufo-experimental/experience-types';
import { untilAll } from '@atlassian/ufo-experimental/until-helpers';

export const GlobalIssueCreateFromUniversalCreateExperience: UFOExperience = new UFOExperience(
	'global-issue-create-from-universal-create',
	{
		type: ExperienceTypes.Operation,
		performanceType: ExperiencePerformanceTypes.Custom,
		until: untilAll([{ category: 'global-issue-create.create-issue' }]),
	},
);

export const UniversalCreateButtonLoadExperience: UFOExperience = new UFOExperience(
	'universal-create-button-load',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);

export const UniversalCreateButtonInteractiveExperience: UFOExperience = new UFOExperience(
	'universal-create-button-interactive',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);
